import BrandsView from "../BrandsView.vue";
import BrandList from "../Pages/BrandList.vue";
import BrandEditor from "../Pages/BrandEditor.vue";

const routes = [
  {
    path: '/admin/brands',
    component: BrandsView,
    children: [
      {
        path: '',
        name: 'brands-list',
        component: BrandList
      },
      {
        path: 'create',
        name: 'brands-create',
        component: BrandEditor,
      },
      {
        path: ':id/edit',
        name: 'brands-edit',
        component: BrandEditor,
      }
    ]
  }
]

export default routes
